import React from "react";
import { Menu, Dropdown, Tag, Tooltip } from "antd";
import { Tr, Td } from "react-super-responsive-table";
import { useSelector } from "react-redux";
import TimeAgo from "react-timeago";
import Link from "next/link";
import { find } from "lodash";
import {
  VisibilityTwoTone,
  DeleteTwoTone,
  LocalOfferTwoTone,
  EventTwoTone,
  MoreVert,
  HistoryTwoTone,
} from "@material-ui/icons";
import KeywordUrl from "./KeywordUrl";
import RankImpact from "./RankImpact";
import RemoveCheckBox from "./RemoveCheckBox";
import RemoveAction from "./RemoveAction";
import UpdateTagsModal from "./UpdateTagsModal";
import RefreshKeywords from "./RefreshKeywords";
import CPCFormat from "./CPCFormat";
import SearchVolumeFormat from "./SearchVolumeFormat";
import LCIconButton from "../styles/LCIconButton";

const KeywordRow = ({ keyword, domain, type }) => {
  const currentUser = useSelector((state) => state.auth.user);

  const actionMenu = (
    <Menu>
      <Menu.Item
        key="1"
        icon={<VisibilityTwoTone className="menu-action-item-detail" />}
      >
        <Link href={`/keywords/${keyword._id}`}>
          <a>View</a>
        </Link>
      </Menu.Item>
      {currentUser && currentUser.role !== "viewer" && (
        <Menu.Item
          key="2"
          icon={<LocalOfferTwoTone className="menu-action-item-tag" />}
        >
          <UpdateTagsModal keyword={keyword} />
        </Menu.Item>
      )}
      {currentUser && currentUser.role !== "viewer" && (
        <Menu.Item
          style={{ color: "darkred" }}
          key="3"
          icon={<DeleteTwoTone className="menu-action-item-trash" />}
        >
          <RemoveAction keyword={keyword} />
        </Menu.Item>
      )}
    </Menu>
  );

  const dataRowType = () => {
    const iconStyle = { fontSize: "26px", color: "#002f53" };

    switch (type) {
      case "history":
        return (
          <>
            <Td className="ant-table-cell">
              <RemoveCheckBox keywordId={keyword._id} />
            </Td>
            <Td className="ant-table-cell text-left">{keyword.keyword}</Td>
            <Td className="ant-table-cell">
              {keyword.tags.map((tag) => {
                return (
                  <Tag key={`${tag}-${keyword._id}`} color={addColorToTag(tag)}>
                    <LocalOfferTwoTone style={{ width: "12px" }} /> {tag}
                  </Tag>
                );
              })}
            </Td>
            <Td className="ant-table-cell">
              <img
                src={`/icons/${keyword.searchEngine}.svg`}
                alt={keyword.searchEngine}
                width="25px"
              />
            </Td>
            <Td className="ant-table-cell">
              <img
                src={`/flags/${keyword.country}.png`}
                alt={keyword.country}
                width="32px"
              />
            </Td>
            <Td className="ant-table-cell">
              <RankImpact
                rank={keyword.rank}
                scrapedAt={keyword.scrapedAt}
                rankStatus={keyword.rankStatus}
                rankDiffFromLastTime={keyword.rankDiffFromLastTime}
              />
            </Td>
            <Td className="ant-table-cell">
              <RankImpact
                rank={keyword.highestRank}
                scrapedAt={keyword.scrapedAt}
              />
            </Td>
            <Td className="ant-table-cell">
              <RankImpact
                rank={keyword.intialRank}
                scrapedAt={keyword.scrapedAt}
              />
            </Td>
            <Td className="ant-table-cell">
              <Link href={`/keywords/${keyword._id}`}>
                <LCIconButton>
                  <HistoryTwoTone />
                </LCIconButton>
              </Link>
            </Td>
          </>
        );
      case "snapshot":
        return (
          <>
            <Td className="ant-table-cell text-left">{keyword.keyword}</Td>
            <Td className="ant-table-cell">
              <RankImpact
                rank={keyword.rank}
                scrapedAt={keyword.scrapedAt}
                rankStatus={keyword.rankStatus}
                rankDiffFromLastTime={keyword.rankDiffFromLastTime}
              />
            </Td>
            <Td className="ant-table-cell">{keyword.competition}</Td>
            <Td className="ant-table-cell">
              <SearchVolumeFormat searchVolume={keyword.searchVolume} />
            </Td>
            <Td className="ant-table-cell">
              <CPCFormat cpc={keyword.cpc} country={keyword.country} />
            </Td>
            <Td className="ant-table-cell">
              <TimeAgo date={keyword.scrapedAt} />
            </Td>
            <Td className="ant-table-cell">
              <Link href={`/keywords/${keyword._id}?open=latest`}>
                <LCIconButton>
                  <VisibilityTwoTone />
                </LCIconButton>
              </Link>
            </Td>
          </>
        );
      case "competitor":
        return (
          <>
            <Td className="ant-table-cell text-left">{keyword.keyword}</Td>
            <Td className="ant-table-cell">
              <img
                src={`/icons/${keyword.searchEngine}.svg`}
                alt={keyword.searchEngine}
                width="25px"
              />
            </Td>
            <Td className="ant-table-cell">
              <img
                src={`/flags/${keyword.country}.png`}
                alt={keyword.country}
                width="32px"
              />
            </Td>
            <Td className="ant-table-cell">
              <RankImpact
                rank={keyword.rank}
                scrapedAt={keyword.scrapedAt}
                rankStatus={keyword.rankStatus}
                rankDiffFromLastTime={keyword.rankDiffFromLastTime}
              />
            </Td>
            {[0, 1, 2, 3].map((num) => {
              return (
                <Td className="ant-table-cell">
                  {keyword.competitors[num]
                    ? keyword.competitors[num].domainName
                    : ""}
                </Td>
              );
            })}
          </>
        );
      case "target":
        console.log("Current Domain:", domain);
        return (
          <>
            <Td className="ant-table-cell text-left">{keyword.keyword}</Td>
            <Td className="ant-table-cell">
              <img
                src={`/icons/${keyword.searchEngine}.svg`}
                alt={keyword.searchEngine}
                width="25px"
              />
            </Td>
            <Td className="ant-table-cell">
              <img
                src={`/flags/${keyword.country}.png`}
                alt={keyword.country}
                width="32px"
              />
            </Td>
            <Td className="ant-table-cell">
              <RankImpact
                rank={keyword.rank}
                scrapedAt={keyword.scrapedAt}
                rankStatus={keyword.rankStatus}
                rankDiffFromLastTime={keyword.rankDiffFromLastTime}
              />
            </Td>
            {domain &&
              domain.targets.map((targetName) => {
                const target = find(keyword.targets, (keywordTarget) => {
                  return keywordTarget.domainName === targetName;
                });
                return (
                  <Td className="ant-table-cell">
                    {target ? target.position : ">100"}
                  </Td>
                );
              })}
          </>
        );
      default:
        return (
          <>
            <Td className="ant-table-cell">
              <RemoveCheckBox keywordId={keyword._id} />
            </Td>
            <Td className="ant-table-cell text-left">{keyword.keyword}</Td>
            <Td className="ant-table-cell text-left">
              {console.log(domain)}
              <KeywordUrl keyword={keyword} domain={domain} />
            </Td>
            <Td className="ant-table-cell">
              {keyword.tags.map((tag) => {
                return (
                  <Tag key={`${tag}-${keyword._id}`} color={addColorToTag(tag)}>
                    <LocalOfferTwoTone style={{ width: "12px" }} /> {tag}
                  </Tag>
                );
              })}
            </Td>
            <Td className="ant-table-cell">
              <img
                src={`/icons/${keyword.searchEngine}.svg`}
                alt={keyword.searchEngine}
                width="25px"
              />
            </Td>
            <Td className="ant-table-cell">
              <img
                src={`/flags/${keyword.country}.png`}
                alt={keyword.country}
                width="32px"
              />
            </Td>
            <Td className="ant-table-cell">
              <RankImpact
                rank={keyword.rank}
                scrapedAt={keyword.scrapedAt}
                rankStatus={keyword.rankStatus}
                rankDiffFromLastTime={keyword.rankDiffFromLastTime}
              />
            </Td>
            <Td className="ant-table-cell">
              <SearchVolumeFormat searchVolume={keyword.searchVolume} />
            </Td>
            <Td className="ant-table-cell">
              <CPCFormat cpc={keyword.cpc} country={keyword.country} />
            </Td>
            <Td className="ant-table-cell">
              <a style={{ paddingRight: "10px" }}>
                <RefreshKeywords keyword={keyword} />
              </a>
              <span style={{ paddingRight: "10px" }}>
                <Tooltip
                  placement="bottomLeft"
                  title={
                    <>
                      Checked On <br />
                      <TimeAgo date={keyword.scrapedAt} />
                    </>
                  }
                >
                  <EventTwoTone style={iconStyles} />
                </Tooltip>
              </span>
              <Dropdown.Button
                overlay={actionMenu}
                placement="bottomCenter"
                className="menu-action"
                buttonsRender={([leftButton]) => [
                  leftButton,
                  <LCIconButton>
                    <MoreVert />
                  </LCIconButton>,
                ]}
              ></Dropdown.Button>
            </Td>
          </>
        );
    }
  };

  const addColorToTag = (tag) => {
    const randomColors = [
      "lime",
      "green",
      "cyan",
      "blue",
      "geekblue",
      "purple",
    ];
    return ["important"].includes(tag)
      ? "volcano"
      : randomColors[Math.floor(Math.random() * randomColors.length)];
  };

  const iconStyles = { color: "#002f53", fontSize: "26px" };

  return (
    <Tr className="ant-table-row ant-table-row-level-0">{dataRowType()}</Tr>
  );
};

export default KeywordRow;
